import React from 'react';

import classNames from 'classnames';

import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';

import { Dropdown } from './Dropdown/Dropdown';
import cls from './FileCard.module.css';
import { PrevImage } from './PrevImage/PrevImage';
import { useFileCard } from './useFileCard';

interface IFileCardProps {
    fileInfo: IFIleEntity;
}
export const FileCard = ({ fileInfo }: IFileCardProps) => {
    const {
        onChangeModalMode,
        onChangeCurrentFile,
        finalFileName,
        handleDragStart,
        handleDragEnd,
    } = useFileCard(fileInfo);

    if (!fileInfo) return null;
    return (
        <div
            className={classNames(cls.FileCard)}
            onClick={() => {
                onChangeCurrentFile(fileInfo.id, fileInfo);
                onChangeModalMode('prev');
            }}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            draggable
            data-file-id={fileInfo.id}
        >
            <Dropdown fileInfo={fileInfo} />
            <PrevImage
                mimeType={fileInfo.mimeType}
                name={fileInfo.name}
                previewSvgUrl={fileInfo.previewSvgUrl}
            />
            <div className={cls.name}>{finalFileName}</div>
        </div>
    );
};
